import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "slideClass", "wrapperClass", "renderNode", "containerContent", "swiperNodeRef", "prevControlRef", "nextControlRef", "withControls", "swiper", "controlsResponseArea"];
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import styles from "./styles.pcss";
import { BannerControl } from "./BannerControl";
import { useBannerControls } from "./hooks";
var cnBanner = cnBem('banner-core', styles);
var defaultRender = function defaultRender(node) {
  return node;
};
export var BannerCore = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    _props$slideClass = props.slideClass,
    slideClass = _props$slideClass === void 0 ? 'swiper-slide' : _props$slideClass,
    _props$wrapperClass = props.wrapperClass,
    wrapperClass = _props$wrapperClass === void 0 ? 'swiper-wrapper' : _props$wrapperClass,
    _props$renderNode = props.renderNode,
    renderNode = _props$renderNode === void 0 ? defaultRender : _props$renderNode,
    containerContent = props.containerContent,
    swiperNodeRef = props.swiperNodeRef,
    prevControlRef = props.prevControlRef,
    nextControlRef = props.nextControlRef,
    withControls = props.withControls,
    swiper = props.swiper,
    controlsResponseArea = props.controlsResponseArea,
    otherProps = _objectWithoutProperties(props, _excluded);
  var nodes = React.Children.toArray(children);
  var _useBannerControls = useBannerControls({
      withControls: withControls,
      swiperNodeRef: swiperNodeRef,
      swiper: swiper,
      controlsResponseArea: controlsResponseArea
    }),
    showNextControl = _useBannerControls.showNextControl,
    showPrevControl = _useBannerControls.showPrevControl;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnBanner(null, [className, 'swiper']),
    ref: combineRefs([swiperNodeRef, ref])
  }, otherProps, {
    "data-t-id": "components-Banner"
  }), containerContent, withControls && /*#__PURE__*/React.createElement(BannerControl, {
    className: cnBanner('control', {
      side: 'left',
      visible: showPrevControl
    }),
    direction: "prev",
    ref: prevControlRef
  }), /*#__PURE__*/React.createElement("div", {
    className: cnBanner('wrapper', [wrapperClass])
  }, nodes.map(function (node, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: cnBanner('slide', [slideClass]),
      key: cnBanner('slide', {
        i: i
      })
    }, renderNode(node, i));
  })), withControls && /*#__PURE__*/React.createElement(BannerControl, {
    className: cnBanner('control', {
      side: 'right',
      visible: showNextControl
    }),
    direction: "next",
    ref: nextControlRef
  }));
});